/* eslint-disable @typescript-eslint/naming-convention */
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { dataUrlMethod } from 'app/components/datagrid/datagrid.interface';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import { NgEventBus } from 'ng-event-bus';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class QuotationService {
  get estimateURL(): string{
    return `${this.dataCollectorService.baseurl()}/estimate/`;
  }
  get paymentProviderUrl(): string{
    return `${this.dataCollectorService.baseurl()}/payments/provider`;
  }
  get quotationAPIUrls(): any{
    return {
      dataUrl : this.estimateURL+'filter',
      columnUrl: this.estimateURL+'meta',
      filterUrl: this.estimateURL+'meta/filter',
      bulkActionUrl: this.estimateURL+'bulk_action',
      paymentUrl: `${this.dataCollectorService.baseurl()}/customer_portal/estimates/collect_deposit`,
      noteAttachmentUrl: `${this.dataCollectorService.baseurl()}/note_attachment`,
      invoiceUrl: `${this.dataCollectorService.baseurl()}/invoice`,
      dataUrlMethod: dataUrlMethod.POST,
      templateUrl: `${this.dataCollectorService.baseurl()}/invoice_estimate/template`
    };
  }
  quotationDetailsLoaded: Subject<boolean> = new Subject<boolean>();
  refreshQuotationDetails: Subject<any> = new Subject();
  currentQuotationDetails: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(private dataCollectorService: DataCollectorService, private _eventBus: NgEventBus) {
      this.quotationDetailsLoaded.next(false);
  }

  getSummaryUrl(): string{
    return `${this.dataCollectorService.baseurl()}/analytics/estimate`;
  }

  getDiscountFees(): string {
    return `${this.dataCollectorService.baseurl()}/products/discount_fees`;
  }

  getDeleteURL(estimateUid: string): string{
      return this.estimateURL+`${estimateUid}`;
  }

  getQuotationUrl(estimateUid: string): string {
    return this.estimateURL+`${estimateUid}`;
  }

  getFinancingPromoUrl(): string {
    return this.dataCollectorService.baseurl() + '/financing/payments/promo';
  }

  updateQuotationStatus(estimate): Observable<any>{
      const estimateURL = this.estimateURL+`${estimate.estimate_uid}/status`;
      const payload  = estimate;
      return this.dataCollectorService.putData(estimateURL,payload).pipe(tap((data)=>{
        this.castQuotationEvent('status_update', {
          estimate_uid: estimate.estimate_uid,
          status: estimate.estimate_status
        });
      }));
  }

  printAndDownloadPDF(estimateUid, payload): Observable<HttpResponse<Blob>> {
    const estimateURL = this.estimateURL+`${estimateUid}/send`;
    return this.dataCollectorService.postData(estimateURL,payload,{ responseType: 'blob', observe: 'response' });
  }

  sendQuotation(estimateUid,sendData): Observable<any>{
    const estimateURL = this.estimateURL+`${estimateUid}/send`;
    return this.dataCollectorService.postData(estimateURL,sendData);
  }

  collectDeposit(estimateUid, data): Observable<any> {
    const estimateURL = this.estimateURL+`${estimateUid}/deposit`;
    return this.dataCollectorService.putData(estimateURL,data);
  }

  prequalifyTheQuotation(estimate): Observable<any>{
    const url = this.dataCollectorService.baseurl() + '/financing/payments/prequalify';
    const payload = estimate;
    return this.dataCollectorService.postData(url,payload);
  }

  updateQuoteDetails(estimateUid, payload): Observable<any>{
    const url = this.dataCollectorService.baseurl()+'/estimate/' + estimateUid;
    return this.dataCollectorService.putData(url, payload).pipe(tap((data)=>{
      this.castQuotationEvent('update', {
        estimate_uid: estimateUid
      });
    }));
  }

  deleteQuotation(estimateUid): Observable<any>{
    const url = this.getDeleteURL(estimateUid);
    return this.dataCollectorService.deleteData(url).pipe(tap(()=>{
      this.castQuotationEvent('delete', {
        estimate_uid: estimateUid
      });
    }));
  }

  castQuotationEvent(event, data): void{
    this._eventBus.cast('sdk:estimate:' + event, data);
  }

}
